<div class="wrapper">
  <div class="header">
    <div class="header-content">
      <div class="create-header">
        <div class="create-title">Pick date & time</div>
      </div>
    </div>
    <pdq-button class="close" icon="close" variant="ghost" (onClick)="close()"></pdq-button>
  </div>
  <div class="content">
    <mat-calendar [(selected)]="lastTimeSnoozed" [minDate]="minDate"></mat-calendar>
    <div class="date-time" [formGroup]="dateTimeForm">
      <div class="date-value">
        {{ lastTimeSnoozed | date: 'MMM dd, YYYY' }}
      </div>
      <div class="time-value">
        <pdq-input
          formControlName="hour"
          variant="form"
          min="1"
          max="12"
          background="default"
          width="40"
          type="number"
          [invalid]="!dateTimeForm.controls['hour'].valid && dateTimeForm.controls['hour'].dirty"
          [border]="true">
        </pdq-input>
        :
        <pdq-input
          formControlName="minutes"
          variant="form"
          min="0"
          max="59"
          [invalid]="!dateTimeForm.controls['minutes'].valid && dateTimeForm.controls['minutes'].dirty"
          type="number"
          background="default"
          width="40"
          [border]="true">
        </pdq-input>
        <pdq-dropdown mode="default" formControlName="timeUnit" [options]="timeUnits" [defaultOption]="timeUnits[0]">
        </pdq-dropdown>
      </div>
      <div class="time-error">
        {{ timeError }}
      </div>
    </div>
  </div>
  <div class="footer">
    <pdq-button [disabled]="isLoading" variant="light" label="Cancel" (onClick)="close()"></pdq-button>
    <pdq-button
      [disabled]="!dateTimeForm.valid || !lastTimeSnoozed"
      variant="primary"
      label="Snooze"
      (onClick)="scheduleOrders()"
      [loading]="isLoading"></pdq-button>
  </div>
</div>
